var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlratvLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 417.2 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st4 {\n        fill: #ac6c24;\n      }\n\n      .st5 {\n        fill: url(#radial-gradient);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 58.8,
    cy: 56.5,
    fx: 58.8,
    fy: 56.5,
    r: 52.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#f0ddb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7c989"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 59,
    y1: 100.1,
    x2: 59,
    y2: 11.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 84.1,
    y1: 17.9,
    x2: 92.9,
    y2: 91.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe1c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e6c88a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efe1c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 37.6,
    y1: 33.4,
    x2: 23,
    y2: 57.8,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: -4308.3,
    y1: 7966.6,
    x2: -5649.8,
    y2: 10397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe1c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6c47c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 17.7,
    y1: 77.3,
    x2: 25.7,
    y2: 63.5,
    xlinkHref: "#linear-gradient3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 59,
    cy: 56,
    r: 52.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.2,10l2.1,2.9-3.5.9c0-1.5.4-2.7,1.5-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75.8,11.8c.7,1.5,1.4,3,2,4.4l-3.9-1.6c.7-1.5,1.1-2.1,1.9-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M89.2,88.1c-.2,1.7-.4,3.4-.6,4.8-1.2-.3-2.2-1-2.8-1.9,1.2-.9,2.4-1.9,3.4-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.6,82.3s-1.3,3.6-.8,4.2c.7.8,3.9-.4,3.9-.4-1.4-1.6-1.7-1.9-3.1-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.8,76.1c0,.1-.5,3.2-.4,5.6,1.8-.5,2.7-1.8,2.7-1.8-.8-1.1-2.2-3.8-2.2-3.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 59,
    cy: 56,
    r: 44.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.1,19.4c2.8,8.7,5.5,20.1,6.6,33.6,1.1,13.7.3,25-1,34.1-1.8,2.2-4.1,4.2-6,5.8,1.3-9.8,2.1-23.2,0-38.9-2.5-18.2-8.1-32.5-12.8-42.2,2.5,1.1,4.3,1.6,7.5,3.6,1.7,1.1,4.5,2.9,5.8,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.7,36.1c-6.6,4.2-12.3,10.3-14.3,18.2-.2,1-.4,2-.6,3,0-1-.1-1.9-.1-2.9s0-.2,0-.3c0-9,3.9-17,10-22.7,1.7,1,4,3,5,4.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.3,62.6c-.6-10-3.3-28.4-15.3-53.2,0,0-4.8-.8-9.5-.6-4.7.1-9.3,1.2-9.3,1.2,9.3,12.7,15.4,24.2,19.4,32.7,0,0,10.3,22,5.7,31.3-1.4,2.7-3.5,3.9-3.5,3.9-2.7,1.4-5.6.5-6.1.4-3.4-1-5.8-4.2-7.4-6.3h0c-6.7-9-8.8-11-11.6-11.2-1.5-.1-2.6.3-3.1.5-8.5,3.3-5,20.3-13.7,24.5-1.5.7-4.3,1.5-4.9.8,1.9,2.3,4.1,4.4,6.4,6.3.5-.2,1.1-.5,1.6-.8,7.3-4.7,5.2-19.8,11.1-22.5.7-.3,1.2-.3,1.3-.4,3.1-.2,5.3,4,8.1,7.8,2.8,3.7,6.7,9.1,12,10.5,4.9,1.3,10.5-.9,13.8-4.1,4.9-4.6,5.6-11.6,5.1-20.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.6,77.5c.5-3.8,1.6-9.4,4.8-16-3.8,3.4-5.9,6.9-7,9.2-.6,1.2-1.3,2.6-1.8,4.1,1.1,2.4,2.3,4.8,3.7,7,0-1.1,0-2.5.3-4.3Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M172.8,73.5h-15.5l-2.7-6.4h-17.7l-2.6,6.4h-14.8l16.3-36.5h20.7l16.3,36.5ZM145.6,46.2l-4.7,11.6h10l-4.7-11.6h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.3,73.5h-34.2v-36.5h13.7v25.8h20.5v10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.9,73.5h-13.7v-36.5h25.8c12.4,0,16.4,2.5,16.4,9.8v1c0,5.4-1.9,8-7.3,8.7v.5c5.2.7,7.3,1.8,7.3,8.7v7.8h-13.7v-7.6c0-2.7-.7-3.6-5.8-3.6h-9v11.2ZM225.9,46.2v6.9h11.3c2.3,0,3.5-.8,3.5-3.1v-.3c0-2.8-1.1-3.5-5.5-3.5h-9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.3,73.5h-15.5l-2.7-6.4h-17.7l-2.6,6.4h-14.8l16.3-36.5h20.7l16.3,36.5ZM282.1,46.2l-4.7,11.6h10l-4.7-11.6h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.4,73.5h-13.7v-25.8h-12.3v-10.7h38.6v10.7h-12.5v25.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.1,73.5h-17.4l-16.3-36.5h15.9l9.3,23.6h.5l9.4-23.6h14.7l-16.2,36.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlratvLogo);
export default __webpack_public_path__ + "static/media/alratv-logo.55e1e73bbb62afd207b40a69845d2b2d.svg";
export { ForwardRef as ReactComponent };